


import * as React from "react"
import Svg, { G, Path  } from "react-native-svg"

const SliderThumbIcon = (props: any) => {
    return (
        <Svg width="16" height="15" viewBox="0 0 16 15" fill="none" {...props}>
            <Path d="M4.56927 13.0283L0.864196 8.26367C0.615565 7.94389 0.499965 7.60829 0.499939 7.24316C0.499939 6.92353 0.588506 6.62638 0.777282 6.34277L0.864197 6.22168L4.56927 1.45703L4.56927 13.0283Z" fill={props?.color ?? "#2D57D9"} stroke={props?.color ?? "#2D57D9"} />
            <Path d="M15.2723 7.24316C15.2723 7.56283 15.1838 7.85992 14.9949 8.14355L14.908 8.26367L11.2029 13.0283L11.2029 1.45703L14.908 6.22168C15.1568 6.54155 15.2723 6.87793 15.2723 7.24316Z" fill={props?.color ?? "#2D57D9"} stroke={props?.color ?? "#2D57D9"} />
        </Svg>
    )
}

export default SliderThumbIcon
